import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ThumbsDownIcon, ThumbsUpIcon } from '../components/icons'
import { apiJson, apiVoid } from '../lib/api'

/**
 * Yanit basina begeni/begenmeme.
 *
 * ## Iyimser guncelleme, geri alinabilir
 *
 * Tiklama ANINDA gorunuyor, sonra sunucuya gidiyor. Hata olursa eski hale
 * DONUYOR: sessizce basarili gostermek kullaniciya oyunun kaydedildigini
 * dusundururdu ve o yanlis bilgi geri bildirimin butun degerini yok eder.
 *
 * ## Ayni butona ikinci tiklama oyu KALDIRIYOR
 *
 * Yanlislikla tiklamayi geri almanin baska bir yolu olmazdi. Sunucu tarafinda
 * oy yokken de `DELETE` 204 donuyor, yani hizli iki tiklama anlamsiz bir hata
 * uretmiyor.
 *
 * ## Sebep SORULUYOR, zorunlu DEGIL
 *
 * Begenmemeden sonra kisa bir liste aciliyor ve atlanabiliyor. Zorunlu tutmak geri
 * bildirimi oldururdu: kullanici bir tiklama yapmak istiyor, form doldurmak
 * istemiyor.
 */

export interface FeedbackState {
  rating: 'up' | 'down'
  reason: string | null
}

// Anahtarlar SUNUCUDAKI degerler; cevrilen yalnizca etiket. Ikisini
// birlestirmek, ceviri degistiginde sunucuya gonderilen degerin de
// degismesi demek olurdu.
const REASON_KEYS = ['wrong', 'irrelevant', 'too_long', 'tool_error'] as const

export function Feedback({
  messageId,
  value,
  onChange,
}: {
  messageId: string
  value: FeedbackState | null
  onChange(next: FeedbackState | null): void
}) {
  const { t } = useTranslation()
  const [askReason, setAskReason] = useState(false)
  const [failed, setFailed] = useState(false)

  async function vote(rating: 'up' | 'down') {
    const previous = value
    setFailed(false)

    // Ayni oya ikinci tiklama = geri al.
    if (value?.rating === rating) {
      onChange(null)
      setAskReason(false)
      try {
        await apiVoid(`/api/messages/${messageId}/feedback`, { method: 'DELETE' })
      } catch {
        onChange(previous)
        setFailed(true)
      }
      return
    }

    onChange({ rating, reason: null })
    setAskReason(rating === 'down')
    try {
      await apiJson<FeedbackState>(`/api/messages/${messageId}/feedback`, {
        method: 'PUT',
        body: JSON.stringify({ rating }),
      })
    } catch {
      onChange(previous)
      setAskReason(false)
      setFailed(true)
    }
  }

  async function pickReason(reason: string) {
    const previous = value
    setAskReason(false)
    onChange({ rating: 'down', reason })
    try {
      await apiJson<FeedbackState>(`/api/messages/${messageId}/feedback`, {
        method: 'PUT',
        body: JSON.stringify({ rating: 'down', reason }),
      })
    } catch {
      onChange(previous)
      setFailed(true)
    }
  }

  return (
    <span className="feedback">
      <button
        type="button"
        className={value?.rating === 'up' ? 'copy feedback-on' : 'copy'}
        onClick={() => void vote('up')}
        // `aria-pressed` SART: gorsel vurgu tek basina ekran okuyucuya
        // hicbir sey anlatmiyor ve bu bir ac/kapa dugmesi.
        aria-pressed={value?.rating === 'up'}
        aria-label={t('feedback.up')}
      >
        <ThumbsUpIcon />
      </button>
      <button
        type="button"
        className={value?.rating === 'down' ? 'copy feedback-on' : 'copy'}
        onClick={() => void vote('down')}
        aria-pressed={value?.rating === 'down'}
        aria-label={t('feedback.down')}
      >
        <ThumbsDownIcon />
      </button>

      {askReason && (
        <span className="feedback-reasons" role="group" aria-label={t('feedback.reasonGroup')}>
          {REASON_KEYS.map((reason) => (
            <button
              key={reason}
              type="button"
              className="copy"
              onClick={() => void pickReason(reason)}
            >
              {t(`feedback.reason.${reason}`)}
            </button>
          ))}
          {/*
            Atlama YOLU acik: sebep zorunlu olmadigi icin kullanicinin
            listeyi kapatabilmesi gerekiyor. Aksi halde tek cikis yolu
            sayfayi yenilemek olurdu.
          */}
          <button type="button" className="copy" onClick={() => setAskReason(false)}>
            {t('feedback.skip')}
          </button>
        </span>
      )}

      {failed && (
        <span className="feedback-error" role="alert">
          {t('feedback.failed')}
        </span>
      )}
    </span>
  )
}
